/**
 * This file was auto-generated by openapi-typescript.
 * Do not make direct changes to the file.
 */

export interface paths {
    '/v1/messaging/message-templates': {
        parameters: {
            query?: never
            header?: never
            path?: never
            cookie?: never
        }
        /**
         * Display a listing of Message Templates.
         *     Also includes filtering for soft deleted items
         */
        get: operations['message-templates.index']
        put?: never
        /** Store a newly created resource in storage */
        post: operations['message-templates.store']
        delete?: never
        options?: never
        head?: never
        patch?: never
        trace?: never
    }
    '/v1/messaging/message-templates/{id}/restore': {
        parameters: {
            query?: never
            header?: never
            path?: never
            cookie?: never
        }
        get?: never
        put?: never
        post: operations['messageTemplate.restore']
        delete?: never
        options?: never
        head?: never
        patch?: never
        trace?: never
    }
    '/v1/messaging/message-templates/{messageTemplate}': {
        parameters: {
            query?: never
            header?: never
            path?: never
            cookie?: never
        }
        /** Display the specified resource */
        get: operations['message-templates.show']
        put: operations['message-templates.update']
        post?: never
        delete: operations['message-templates.destroy']
        options?: never
        head?: never
        patch?: never
        trace?: never
    }
    '/v1/messaging/message-templates/{messageTemplate}/send-test': {
        parameters: {
            query?: never
            header?: never
            path?: never
            cookie?: never
        }
        get?: never
        put?: never
        post: operations['message-templates.send-test']
        delete?: never
        options?: never
        head?: never
        patch?: never
        trace?: never
    }
    '/v1/messaging/scheduled-messages': {
        parameters: {
            query?: never
            header?: never
            path?: never
            cookie?: never
        }
        /**
         * Display a listing of Scheduled Messages.
         *     Also includes filtering for soft deleted items
         */
        get: operations['scheduled-messages.index']
        put?: never
        /** Store a newly created resource in storage */
        post: operations['scheduled-messages.store']
        delete?: never
        options?: never
        head?: never
        patch?: never
        trace?: never
    }
    '/v1/messaging/scheduled-messages/{id}/restore': {
        parameters: {
            query?: never
            header?: never
            path?: never
            cookie?: never
        }
        get?: never
        put?: never
        post: operations['scheduledMessage.restore']
        delete?: never
        options?: never
        head?: never
        patch?: never
        trace?: never
    }
    '/v1/messaging/scheduled-messages/{scheduledMessage}': {
        parameters: {
            query?: never
            header?: never
            path?: never
            cookie?: never
        }
        get?: never
        put: operations['scheduled-messages.update']
        post?: never
        delete: operations['scheduled-messages.destroy']
        options?: never
        head?: never
        patch?: never
        trace?: never
    }
    '/v1/notification': {
        parameters: {
            query?: never
            header?: never
            path?: never
            cookie?: never
        }
        get?: never
        put?: never
        post: operations['notification.create']
        delete?: never
        options?: never
        head?: never
        patch?: never
        trace?: never
    }
    '/v1/notification/{externalUniqueId}': {
        parameters: {
            query?: never
            header?: never
            path?: never
            cookie?: never
        }
        get?: never
        put?: never
        post?: never
        delete: operations['notification.delete']
        options?: never
        head?: never
        patch: operations['notification.patch']
        trace?: never
    }
    '/v1/notification/{userId}': {
        parameters: {
            query?: never
            header?: never
            path?: never
            cookie?: never
        }
        /** Gets all notifications for a user */
        get: operations['notification.get_for_user']
        put?: never
        post?: never
        delete?: never
        options?: never
        head?: never
        patch?: never
        trace?: never
    }
    '/v1/public/notifications': {
        parameters: {
            query?: never
            header?: never
            path?: never
            cookie?: never
        }
        /** Get notifications for a user with various filters */
        get: operations['user.notification.get']
        put?: never
        post?: never
        delete?: never
        options?: never
        head?: never
        patch?: never
        trace?: never
    }
    '/v1/public/notifications/{notificationId}/accept': {
        parameters: {
            query?: never
            header?: never
            path?: never
            cookie?: never
        }
        get?: never
        put?: never
        /** Accept a notification */
        post: operations['user.notification.accept']
        delete?: never
        options?: never
        head?: never
        patch?: never
        trace?: never
    }
    '/v1/public/notifications/{notificationId}/dismiss': {
        parameters: {
            query?: never
            header?: never
            path?: never
            cookie?: never
        }
        get?: never
        put?: never
        /** Dismiss a notification */
        post: operations['user.notification.dismiss']
        delete?: never
        options?: never
        head?: never
        patch?: never
        trace?: never
    }
    '/v1/public/notifications/{notificationId}/shown': {
        parameters: {
            query?: never
            header?: never
            path?: never
            cookie?: never
        }
        get?: never
        put?: never
        /** Log that a notification has been viewed */
        post: operations['user.notification.shown']
        delete?: never
        options?: never
        head?: never
        patch?: never
        trace?: never
    }
    '/v1/public/notifications/read': {
        parameters: {
            query?: never
            header?: never
            path?: never
            cookie?: never
        }
        get?: never
        put?: never
        /** Mark notifications as read */
        post: operations['user.notification.read']
        delete?: never
        options?: never
        head?: never
        patch?: never
        trace?: never
    }
}
export type webhooks = Record<string, never>
export interface components {
    schemas: {
        /**
         * Brand
         * @enum {string}
         */
        Brand: Brand
        /** DeleteNotificationRequest */
        DeleteNotificationRequest: Record<string, never>
        /**
         * EventType
         * @enum {string}
         */
        EventType: EventType
        /** GetNotificationsForUserResponse */
        GetNotificationsForUserResponse: {
            notifications: components['schemas']['RenderedNotification'][]
        }
        /** GetPaginatedNotificationRequest */
        GetPaginatedNotificationRequest: {
            brand?: components['schemas']['Brand'] | null
            category?: components['schemas']['MessageCategory'] | null
            channel?: components['schemas']['NotificationChannel'] | null
            /**
             * @description Whether to exclude expired notifications
             * @default false
             */
            exclude_expired: boolean | null
            /**
             * @description Whether to exclude read notifications
             * @default false
             */
            exclude_read: boolean | null
            limit: number
            offset: number
            presentation_type?: components['schemas']['PresentationType'] | null
        }
        /** GetRawNotificationsForUserResponse */
        GetRawNotificationsForUserResponse: {
            notifications: components['schemas']['Notification'][]
        }
        /** MarkNotificationsAsReadRequest */
        MarkNotificationsAsReadRequest: {
            /** @description The ids of the notifications to mark as read. If not provided, all notifications will be marked as read */
            notificationIds?: string[] | null
        }
        /**
         * MessageCategory
         * @enum {string}
         */
        MessageCategory: MessageCategory
        /**
         * MessageState
         * @enum {string}
         */
        MessageState: MessageState
        /** MessageTemplate */
        MessageTemplate: {
            body: string | null
            /** Format: date-time */
            created_at: string | null
            data: unknown[] | null
            /** Format: date-time */
            deleted_at: string | null
            id: number
            message_type: components['schemas']['MessageType']
            name: string
            presentation_type: components['schemas']['PresentationType']
            priority: number
            title: string
            /** Format: date-time */
            updated_at: string | null
        }
        /** MessageTemplateData */
        MessageTemplateData: {
            actions?: components['schemas']['TemplateActionData'][] | null
            body?: string | null
            /** @default [] */
            data: unknown[] | null
            message_type: components['schemas']['MessageType']
            name: string
            presentation_type: components['schemas']['PresentationType']
            priority: number
            title: string
        }
        /** MessageTemplateFilterData */
        MessageTemplateFilterData: {
            /** @enum {string|null} */
            trashed?: MessageTemplateFilterDataTrashed
        }
        /**
         * MessageType
         * @enum {string}
         */
        MessageType: MessageType
        /** Notification */
        Notification: {
            acceptAction: components['schemas']['NotificationAction'] | null
            /** @description The body of the notification shown to the user. Should be translated. Can use Liquid syntax. HTML welcome */
            body: string | null
            brand: components['schemas']['Brand'] | null
            /**
             * Format: date-time
             * @description The time the notification was created
             */
            createdAt: string
            /**
             * @description The data of the notification shown to the user. Can be used in the Liquid template, and will be returned in callbacks
             * @default []
             */
            data: Record<string, never>[]
            dismissAction: components['schemas']['NotificationAction'] | null
            /**
             * Format: date-time
             * @description The time the notification should be displayed as created. If not provided, the current timestamp will be used
             */
            displayedCreatedAt: string | null
            /**
             * Format: date-time
             * @description If not null, the time the notification should be marked as expired
             */
            expiresAt: string | null
            externalUniqueId: string
            /** @description The unique identifier for the notification */
            id: string
            presentationType: components['schemas']['PresentationType'] | null
            priority: number
            /** @description Whether the notification has been read by the user */
            read: boolean
            /**
             * Format: date-time
             * @description The time the notification was read by the user
             */
            readAt: string | null
            /** @description The session id of the user that read the notification */
            readBySessionId: number | null
            state: components['schemas']['MessageState']
            /** @description The title of the notification shown to the user. Should be translated. Can use Liquid syntax. Do not use HTML tags */
            title: string
            type: components['schemas']['MessageType']
            /**
             * Format: date-time
             * @description The time the notification was last updated
             */
            updatedAt: string
            userId: number
        }
        /** NotificationAction */
        NotificationAction: {
            /**
             * @description The reaction action to take on the notification once the action has been taken. Defaults to REMOVE_ACCEPT
             * @default REMOVE_ACCEPT
             */
            reaction: components['schemas']['NotificationReactionAction']
            redirect: string | null
            /** @description The text of the action button. If not set, no action button will be shown. Supports blade syntax. Do not use HTML tags */
            template: string | null
            /** @description The webhook to call when the user has clicked the action button. Will be a POST request, @see App\DataTransferObjects\Notification\WebhookRequest */
            webhook: string | null
        }
        /** NotificationActionRequest */
        NotificationActionRequest: {
            /**
             * @description The reaction action to take on the notification once the action has been taken. Defaults to REMOVE_ACCEPT
             * @default REMOVE_ACCEPT
             */
            reaction: components['schemas']['NotificationReactionAction']
            redirect?: string | null
            /** @description The text of the action button. If not set, no action button will be shown. Supports blade syntax. Do not use HTML tags */
            template?: string | null
            /** @description The webhook to call when the user has clicked the action button. Will be a POST request, @see App\DataTransferObjects\Notification\WebhookRequest */
            webhook?: string | null
        }
        /**
         * NotificationActionType
         * @enum {string}
         */
        NotificationActionType: NotificationActionType
        /**
         * NotificationChannel
         * @enum {string}
         */
        NotificationChannel: NotificationChannel
        /**
         * NotificationReactionAction
         * @enum {string}
         */
        NotificationReactionAction: NotificationReactionAction
        /** PatchNotificationRequest */
        PatchNotificationRequest: {
            acceptAction?: components['schemas']['NotificationActionRequest'] | null
            /** @description The body of the notification shown to the user. Should be translated. Can use Liquid syntax. HTML welcome */
            body?: string | null
            brand?: components['schemas']['Brand'] | null
            /** @description The data of the notification shown to the user. Can be used in the Liquid template, and will be returned in callbacks */
            data?: Record<string, never>[]
            dismissAction?: components['schemas']['NotificationActionRequest'] | null
            /**
             * Format: date-time
             * @description If not null, the time the notification should be sent
             */
            expiresAt?: string | null
            state?: components['schemas']['MessageState']
            /** @description The title of the notification shown to the user. Should be translated. Can use Liquid syntax. Do not use HTML tags */
            title?: string
        }
        /**
         * PresentationType
         * @enum {string}
         */
        PresentationType: PresentationType
        /** RenderedNotification */
        RenderedNotification: {
            acceptAction: components['schemas']['RenderedNotificationAction'] | null
            /** @description The body of the notification */
            body: string | null
            channel: components['schemas']['NotificationChannel'] | null
            /**
             * Format: date-time
             * @description The time the notification was created
             */
            created_at: string
            /** @description Contextual data for the notification */
            data: Record<string, never>[]
            dismissAction: components['schemas']['RenderedNotificationAction'] | null
            /**
             * Format: date-time
             * @description The time the notification should be showen as created
             */
            displayed_created_at: string
            /**
             * Format: date-time
             * @description The time the notification expires
             */
            expires_at: string | null
            /** @description The unique external identifier for the notification */
            externalUniqueId: string
            /** @description The unique identifier for the notification must be a UUID */
            id: string
            /** @description The presentation type for the notification */
            presentation_type: components['schemas']['PresentationType']
            /** @description Priority of the notification, higher numbers indicate higher priority */
            priority: number
            /** @description Whether the notification has been read */
            read: boolean
            /**
             * Format: date-time
             * @description The time the notification was read
             */
            read_at: string | null
            /** @description The state of the notification */
            state: components['schemas']['MessageState']
            /** @description The title of the notification */
            title: string
            /** @description The slug/type of the notification, typically used to group notifications into types */
            type: components['schemas']['MessageType']
        }
        /** RenderedNotificationAction */
        RenderedNotificationAction: {
            /** @description The callback URL which should be called when the user clicks the button by the frontend */
            callback: string
            /** @description The redirect, if not null, that should be redirected to once the action has been taken and the callback has been called */
            redirect: string | null
            /** @description The rendered text of the action button */
            text: string
        }
        /** ScheduledMessageData */
        ScheduledMessageData: {
            description?: string | null
            event_types: components['schemas']['EventType'][]
            /** Format: date-time */
            expires_at?: string | null
            is_recurring: boolean
            max_send_count?: number | null
            max_send_count_per_user?: number | null
            recurring_interval_minutes?: number | null
            rules?: string | null
            /** Format: date-time */
            scheduled_from?: string | null
            /** Format: date-time */
            scheduled_to?: string | null
            state?: components['schemas']['ScheduledMessageState'] | null
            template_id: number
        }
        /** ScheduledMessageFilterData */
        ScheduledMessageFilterData: {
            /** @enum {string|null} */
            trashed?: ScheduledMessageFilterDataTrashed
        }
        /**
         * ScheduledMessageState
         * @enum {string}
         */
        ScheduledMessageState: ScheduledMessageState
        /** SendNotificationRequest */
        SendNotificationRequest: {
            acceptAction?: components['schemas']['NotificationActionRequest'] | null
            /** @description The body of the notification shown to the user. Should be translated. Can use Liquid syntax. HTML welcome */
            body?: string | null
            brand?: components['schemas']['Brand'] | null
            /**
             * @description The data of the notification shown to the user. Can be used in the Liquid template, and will be returned in callbacks
             * @default []
             */
            data: Record<string, never>[]
            dismissAction?: components['schemas']['NotificationActionRequest'] | null
            /**
             * Format: date-time
             * @description The time the notification should be displayed as created. If not provided, the current timestamp will be used
             */
            displayedCreatedAt?: string | null
            /**
             * Format: date-time
             * @description If not null, the time the notification should be marked as expired
             */
            expiresAt?: string | null
            externalUniqueId: string
            presentationType?: components['schemas']['PresentationType'] | null
            priority: number
            state: components['schemas']['MessageState']
            /** @description The title of the notification shown to the user. Should be translated. Can use Liquid syntax. Do not use HTML tags */
            title: string
            type: components['schemas']['MessageType']
            userId: number
        }
        /** SendNotificationResponse */
        SendNotificationResponse: {
            /** @description The unique identifier for the notification */
            id: string
        }
        /** SendTestNotificationData */
        SendTestNotificationData: {
            user_id: number
        }
        /** TemplateActionData */
        TemplateActionData: {
            reaction: components['schemas']['NotificationReactionAction']
            redirect?: string | null
            template: string
            type: components['schemas']['NotificationActionType']
            webhook?: string | null
        }
    }
    responses: {
        /** @description Not found */
        ModelNotFoundException: {
            headers: {
                [name: string]: unknown
            }
            content: {
                'application/json': {
                    /** @description Error overview. */
                    message: string
                }
            }
        }
        /** @description Validation error */
        ValidationException: {
            headers: {
                [name: string]: unknown
            }
            content: {
                'application/json': {
                    /** @description A detailed description of each field that failed validation. */
                    errors: {
                        [key: string]: string[]
                    }
                    /** @description Errors overview. */
                    message: string
                }
            }
        }
    }
    parameters: never
    requestBodies: never
    headers: never
    pathItems: never
}
export type $defs = Record<string, never>
export interface operations {
    'message-templates.index': {
        parameters: {
            query?: {
                trashed?: PathsV1MessagingMessageTemplatesGetParametersQueryTrashed
            }
            header?: never
            path?: never
            cookie?: never
        }
        requestBody?: never
        responses: {
            200: {
                headers: {
                    [name: string]: unknown
                }
                content: {
                    'application/json': string
                }
            }
            422: components['responses']['ValidationException']
        }
    }
    'message-templates.store': {
        parameters: {
            query?: never
            header?: never
            path?: never
            cookie?: never
        }
        /** @description `MessageTemplateData` */
        requestBody: {
            content: {
                'application/json': components['schemas']['MessageTemplateData']
            }
        }
        responses: {
            201: {
                headers: {
                    [name: string]: unknown
                }
                content: {
                    'application/json': {
                        /** @constant */
                        message: 'Message template created successfully'
                    }
                }
            }
            422: components['responses']['ValidationException']
        }
    }
    'messageTemplate.restore': {
        parameters: {
            query?: never
            header?: never
            path: {
                id: string
            }
            cookie?: never
        }
        requestBody?: never
        responses: {
            200: {
                headers: {
                    [name: string]: unknown
                }
                content: {
                    'application/json': {
                        /** @constant */
                        message: 'Message template restored successfully'
                    }
                }
            }
        }
    }
    'message-templates.show': {
        parameters: {
            query?: never
            header?: never
            path: {
                /** @description The message template ID */
                messageTemplate: number
            }
            cookie?: never
        }
        requestBody?: never
        responses: {
            200: {
                headers: {
                    [name: string]: unknown
                }
                content: {
                    'application/json': components['schemas']['MessageTemplate']
                }
            }
            404: components['responses']['ModelNotFoundException']
        }
    }
    'message-templates.update': {
        parameters: {
            query?: never
            header?: never
            path: {
                /** @description The message template ID */
                messageTemplate: number
            }
            cookie?: never
        }
        /** @description `MessageTemplateData` */
        requestBody: {
            content: {
                'application/json': components['schemas']['MessageTemplateData']
            }
        }
        responses: {
            200: {
                headers: {
                    [name: string]: unknown
                }
                content: {
                    'application/json': {
                        /** @constant */
                        message: 'Message template updated successfully'
                    }
                }
            }
            404: components['responses']['ModelNotFoundException']
            422: components['responses']['ValidationException']
        }
    }
    'message-templates.destroy': {
        parameters: {
            query?: never
            header?: never
            path: {
                /** @description The message template ID */
                messageTemplate: number
            }
            cookie?: never
        }
        requestBody?: never
        responses: {
            200: {
                headers: {
                    [name: string]: unknown
                }
                content: {
                    'application/json': {
                        /** @constant */
                        message: 'Message template deleted successfully'
                    }
                }
            }
            404: components['responses']['ModelNotFoundException']
        }
    }
    'message-templates.send-test': {
        parameters: {
            query?: never
            header?: never
            path: {
                /** @description The message template ID */
                messageTemplate: number
            }
            cookie?: never
        }
        /** @description `SendTestNotificationData` */
        requestBody: {
            content: {
                'application/json': components['schemas']['SendTestNotificationData']
            }
        }
        responses: {
            201: {
                headers: {
                    [name: string]: unknown
                }
                content: {
                    'application/json': {
                        message: string
                        notification_id: string
                    }
                }
            }
            403: {
                headers: {
                    [name: string]: unknown
                }
                content: {
                    'application/json': {
                        /** @constant */
                        message: 'User is not staff'
                    }
                }
            }
            404: components['responses']['ModelNotFoundException']
            422: components['responses']['ValidationException']
        }
    }
    'scheduled-messages.index': {
        parameters: {
            query?: {
                trashed?: PathsV1MessagingScheduledMessagesGetParametersQueryTrashed
            }
            header?: never
            path?: never
            cookie?: never
        }
        requestBody?: never
        responses: {
            200: {
                headers: {
                    [name: string]: unknown
                }
                content: {
                    'application/json': string
                }
            }
            422: components['responses']['ValidationException']
        }
    }
    'scheduled-messages.store': {
        parameters: {
            query?: never
            header?: never
            path?: never
            cookie?: never
        }
        /** @description `ScheduledMessageData` */
        requestBody: {
            content: {
                'application/json': components['schemas']['ScheduledMessageData']
            }
        }
        responses: {
            201: {
                headers: {
                    [name: string]: unknown
                }
                content: {
                    'application/json': {
                        /** @constant */
                        message: 'Scheduled message created successfully'
                    }
                }
            }
            422: components['responses']['ValidationException']
        }
    }
    'scheduledMessage.restore': {
        parameters: {
            query?: never
            header?: never
            path: {
                id: string
            }
            cookie?: never
        }
        requestBody?: never
        responses: {
            200: {
                headers: {
                    [name: string]: unknown
                }
                content: {
                    'application/json': {
                        /** @constant */
                        message: 'Scheduled message restored successfully'
                    }
                }
            }
        }
    }
    'scheduled-messages.update': {
        parameters: {
            query?: never
            header?: never
            path: {
                /** @description The scheduled message ID */
                scheduledMessage: number
            }
            cookie?: never
        }
        /** @description `ScheduledMessageData` */
        requestBody: {
            content: {
                'application/json': components['schemas']['ScheduledMessageData']
            }
        }
        responses: {
            200: {
                headers: {
                    [name: string]: unknown
                }
                content: {
                    'application/json': {
                        /** @constant */
                        message: 'Scheduled message updated successfully'
                    }
                }
            }
            404: components['responses']['ModelNotFoundException']
            422: components['responses']['ValidationException']
        }
    }
    'scheduled-messages.destroy': {
        parameters: {
            query?: never
            header?: never
            path: {
                /** @description The scheduled message ID */
                scheduledMessage: number
            }
            cookie?: never
        }
        requestBody?: never
        responses: {
            200: {
                headers: {
                    [name: string]: unknown
                }
                content: {
                    'application/json': {
                        /** @constant */
                        message: 'Scheduled message deleted successfully'
                    }
                }
            }
            404: components['responses']['ModelNotFoundException']
        }
    }
    'notification.create': {
        parameters: {
            query?: never
            header?: never
            path?: never
            cookie?: never
        }
        /** @description `SendNotificationRequest` */
        requestBody: {
            content: {
                'application/json': components['schemas']['SendNotificationRequest']
            }
        }
        responses: {
            200: {
                headers: {
                    [name: string]: unknown
                }
                content: {
                    'application/json': Record<string, never>
                }
            }
            422: components['responses']['ValidationException']
        }
    }
    'notification.delete': {
        parameters: {
            query?: never
            header?: never
            path: {
                externalUniqueId: string
            }
            cookie?: never
        }
        requestBody?: never
        responses: {
            /** @description No content */
            204: {
                headers: {
                    [name: string]: unknown
                }
                content?: never
            }
            422: components['responses']['ValidationException']
        }
    }
    'notification.patch': {
        parameters: {
            query?: never
            header?: never
            path: {
                externalUniqueId: string
            }
            cookie?: never
        }
        /** @description `PatchNotificationRequest` */
        requestBody?: {
            content: {
                'application/json': components['schemas']['PatchNotificationRequest']
            }
        }
        responses: {
            /** @description `SendNotificationResponse` */
            200: {
                headers: {
                    [name: string]: unknown
                }
                content: {
                    'application/json': components['schemas']['SendNotificationResponse']
                }
            }
            422: components['responses']['ValidationException']
        }
    }
    'notification.get_for_user': {
        parameters: {
            query?: {
                trashed?: PathsV1NotificationUserIdGetParametersQueryTrashed
            }
            header?: never
            path: {
                userId: number
            }
            cookie?: never
        }
        requestBody?: never
        responses: {
            /**
             * @description Return a response with the notifications
             *
             *
             *
             *     `GetRawNotificationsForUserResponse`
             */
            200: {
                headers: {
                    [name: string]: unknown
                }
                content: {
                    'application/json': components['schemas']['GetRawNotificationsForUserResponse']
                }
            }
            422: components['responses']['ValidationException']
        }
    }
    'user.notification.get': {
        parameters: {
            query: {
                brand?: components['schemas']['Brand'] | null
                category?: components['schemas']['MessageCategory'] | null
                channel?: components['schemas']['NotificationChannel'] | null
                exclude_expired?: boolean | null
                exclude_read?: boolean | null
                limit: number
                offset: number
                presentation_type?: components['schemas']['PresentationType'] | null
            }
            header?: never
            path?: never
            cookie?: never
        }
        requestBody?: never
        responses: {
            /** @description `GetNotificationsForUserResponse` */
            200: {
                headers: {
                    [name: string]: unknown
                }
                content: {
                    'application/json': components['schemas']['GetNotificationsForUserResponse']
                }
            }
            422: components['responses']['ValidationException']
        }
    }
    'user.notification.accept': {
        parameters: {
            query?: never
            header?: never
            path: {
                notificationId: string
            }
            cookie?: never
        }
        requestBody?: never
        responses: {
            /** @description `RenderedNotification` */
            200: {
                headers: {
                    [name: string]: unknown
                }
                content: {
                    'application/json': components['schemas']['RenderedNotification']
                }
            }
        }
    }
    'user.notification.dismiss': {
        parameters: {
            query?: never
            header?: never
            path: {
                notificationId: string
            }
            cookie?: never
        }
        requestBody?: never
        responses: {
            /** @description `RenderedNotification` */
            200: {
                headers: {
                    [name: string]: unknown
                }
                content: {
                    'application/json': components['schemas']['RenderedNotification']
                }
            }
        }
    }
    'user.notification.shown': {
        parameters: {
            query?: never
            header?: never
            path: {
                notificationId: string
            }
            cookie?: never
        }
        requestBody?: never
        responses: {
            200: {
                headers: {
                    [name: string]: unknown
                }
                content: {
                    'application/json': Record<string, never>
                }
            }
        }
    }
    'user.notification.read': {
        parameters: {
            query?: never
            header?: never
            path?: never
            cookie?: never
        }
        /** @description `MarkNotificationsAsReadRequest` */
        requestBody?: {
            content: {
                'application/json': components['schemas']['MarkNotificationsAsReadRequest']
            }
        }
        responses: {
            200: {
                headers: {
                    [name: string]: unknown
                }
                content: {
                    'application/json': Record<string, never>
                }
            }
            422: components['responses']['ValidationException']
        }
    }
}
export enum PathsV1MessagingMessageTemplatesGetParametersQueryTrashed {
    only = 'only',
    with = 'with',
    without = 'without'
}
export enum PathsV1MessagingScheduledMessagesGetParametersQueryTrashed {
    only = 'only',
    with = 'with',
    without = 'without'
}
export enum PathsV1NotificationUserIdGetParametersQueryTrashed {
    only = 'only',
    with = 'with',
    without = 'without'
}
export enum Brand {
    spilnu = 'spilnu',
    happytiger = 'happytiger',
    spinking = 'spinking',
    bingoburst = 'bingoburst',
    luxcasino = 'luxcasino',
    sweetspin = 'sweetspin',
    jackpotfisher = 'jackpotfisher',
    spinnow = 'spinnow'
}
export enum EventType {
    user_logged_in = 'user_logged_in',
    user_made_withdrawal = 'user_made_withdrawal'
}
export enum MessageCategory {
    News = 'News',
    Promotion = 'Promotion',
    Other = 'Other'
}
export enum MessageState {
    active = 'active',
    expired = 'expired',
    accepted = 'accepted',
    rejected = 'rejected'
}
export enum MessageTemplateFilterDataTrashed {
    only = 'only',
    with = 'with',
    without = 'without'
}
export enum MessageType {
    mentor_message = 'mentor_message',
    game_scanner = 'game_scanner',
    promotion_recurring_consent = 'promotion_recurring_consent',
    game_launch = 'game_launch',
    players_user_report_available = 'players_user_report_available',
    source_of_funds_request = 'source_of_funds_request',
    affordability_limit_notification = 'affordability_limit_notification',
    money_limit_was_reverted = 'money_limit_was_reverted',
    customize_username = 'customize_username',
    withdrawal_status_update = 'withdrawal_status_update',
    suspended_after_extended_kyc_check = 'suspended_after_extended_kyc_check',
    occupation_check = 'occupation_check',
    salary_check = 'salary_check',
    bounce_email_review_profile = 'bounce_email_review_profile',
    promotion_game = 'promotion_game',
    kyc_document_inquiry = 'kyc_document_inquiry',
    kyc_document_approved = 'kyc_document_approved',
    kyc_document_denied = 'kyc_document_denied',
    app_review_request = 'app_review_request',
    promotion_bonus_redeemed = 'promotion_bonus_redeemed',
    money_limits_reminder = 'money_limits_reminder',
    additional_information_request = 'additional_information_request',
    biometric_login_request = 'biometric_login_request',
    withdrawal_request_approved = 'withdrawal_request_approved'
}
export enum NotificationActionType {
    ACCEPT = 'ACCEPT',
    DISMISS = 'DISMISS'
}
export enum NotificationChannel {
    any = 'any',
    app = 'app',
    web = 'web'
}
export enum NotificationReactionAction {
    NONE = 'NONE',
    REMOVE_ACCEPT = 'REMOVE_ACCEPT',
    REMOVE_DISMISS = 'REMOVE_DISMISS',
    REMOVE_ACTIONS = 'REMOVE_ACTIONS'
}
export enum PresentationType {
    notification = 'notification',
    dialog = 'dialog',
    flash = 'flash',
    persistent_dialog = 'persistent_dialog'
}
export enum ScheduledMessageFilterDataTrashed {
    only = 'only',
    with = 'with',
    without = 'without'
}
export enum ScheduledMessageState {
    draft = 'draft',
    active = 'active',
    paused = 'paused',
    reached_cap = 'reached_cap',
    ended = 'ended'
}
